import { api } from "../api";

export type WindowStatus =
  | "weekend"
  | "pre_open"
  | "open"
  | "closing"
  | "post_close";

export interface TradingWindow {
  day: string;
  status: WindowStatus;
  windowStart: number | null;
  windowEnd: number | null;
  forceCloseAt: number | null;
  serverTime: number;
}

export function getTodayWindow(): Promise<TradingWindow> {
  return api.get<TradingWindow>("/api/window/today");
}
